import { ConversationResponder } from "@redotech/redo-model/agents/returns-agents/util/return-reason-conversation-util";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getAiReturnReasonsConversation = {
  name: "getAiReturnReasonsConversation" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z.object({
    messages: z.array(
      z.object({
        responder: createEnum(ConversationResponder),
        text: z.string(),
      }),
    ),
  }),
};
